<template>
  <div v-loading="loading" class="page-content">
    <div class="operate-nav">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="$emit('create', 1)">新建创意</el-button>
    </div>
    <Table
      ref="table"
      :props="table.props"
      :header="table.header"
      :data="table.data"
    />
    <pagination
      :currentpage="pager.pageNo"
      :pagesize="pager.pageSize"
      :totalcount="pager.total"
      @handle-size-change="handleSizeChange"
      @handle-current-change="handleCurrentChange"
    ></pagination>
    <!--详情-->
    <el-drawer
      :visible.sync="showDrawer"
      size="60%"
      :modal="false"
      :destroy-on-close="true"
      class="detail-drawer"
      :with-header="false"
      @reload-content="handleReloadContent"
    >
      <Read v-if="showDrawer" :mediaModel="mediaModel" :tabActiveName="drawerTabsActiveName" @closeDrawer="showDrawer = false"></Read>
    </el-drawer>
  </div>
</template>

<script>
import Read from './MaterialCreativeRead'
import MediaView from '@/components/media/MediaView.vue'

export default {
  components: {
    Read
  },
  inject: ['projectOrder'],
  data() {
    return {
      loading: false,
      table: {
        props: {
          border: 'border',
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '素材',
            prop: 'mediaUrl',
            fixed: 'left',
            'min-width': 380,
            render: (h, { row }) => {
              if (!row.adMedia) {
                return ''
              }
              return <div style="display:flex">
                <div>
                  <MediaView
                    width="80px"
                    height="50px"
                    mediaClassId={row.adMedia.mediaClassId}
                    src={row.adMedia.mediaIcon}
                    previewSrc={row.adMedia.mp4Url}
                  ></MediaView>
                </div>
                <div>
                  <el-tooltip content={row.mateName} placement="top">
                    <div class="cell-content-grid">{row.mateName}</div>
                  </el-tooltip>
                  <div style="padding: 6px 0 0 12px;color:#999">ID: {row.mateId}</div>
                </div>
              </div>
            }
          },
          {
            label: '类型',
            prop: 'mediaClassName',
            'min-width': 150,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.adMedia.adMediaClass.mediaClassName
            }
          },
          {
            label: '时长(秒)',
            prop: 'duration',
            'min-width': 150,
            'show-overflow-tooltip': true
          },
          {
            label: '校验码',
            prop: 'mateCheckCode',
            'min-width': 220,
            'show-overflow-tooltip': true
          },
          {
            label: '所属计划',
            prop: 'scheduleName',
            'min-width': 220,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.adSchedule.scheduleName
            }
          },
          {
            label: '计划单号',
            prop: 'scheduleNo',
            'min-width': 150,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.adSchedule.scheduleNo
            }
          },
          {
            label: '所属订单',
            prop: 'orderName',
            'min-width': 220,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.adOrder.orderName
            }
          },
          {
            label: '订单编号',
            prop: 'orderNo',
            'min-width': 150,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.adOrder.orderNo
            }
          },
          {
            label: '操作',
            prop: 'operate',
            fixed: 'right',
            'min-width': 150,
            render: (h, { row }) => {
              return <div>
                <el-button type="text" class="cell-button" onClick={() => this.handleEdit(row)}>编辑</el-button>
                <el-button type="text" class="cell-button" onClick={() => this.handleRead(row, 'detail')}>详情</el-button>
                <el-dropdown style="margin-left:8px" onCommand={(command) => this.handleCommand(row, command)}>
                  <el-button type="text">
                    <i class="el-icon-more" style="color:#1890FF;line-height:20px;cursor:pointer;transform:rotate(90deg)"></i>
                  </el-button>
                  <el-dropdown-menu style="width: 120px" class="cell-dropdown-menu" slot="dropdown">
                    <el-dropdown-item type="text" command="log">日志</el-dropdown-item>
                    <el-dropdown-item type="text" command="download">下载</el-dropdown-item>
                    <el-dropdown-item type="text" command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            }
          }
        ],
        data: []
      },
      pager: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      showDrawer: false,
      mediaModel: {},
      mediaId: undefined,
      scheduleId: undefined,
      drawerTabsActiveName: 'detail'
    }
  },
  watch: {
    'projectOrder.selectForm': {
      handler(newVal, oldVal) {
        this.pager.pageNo = 1
        this.table.selected = []
        this.fetchData()
      },
      deep: true
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const filter = this.projectOrder.selectForm
      const params = {
        pageNo: this.pager.pageNo,
        pageSize: this.pager.pageSize,
        order: 'desc',
        sort: 'scheduleTdmId',
        orderNo: this.disposalField(filter.orderNo),
        scheduleNo: this.disposalField(filter.scheduleNo),
        checkStatus: this.disposalField(filter.checkStatus),
        spaceId: this.disposalField(filter.spaceId),
        mediaClassId: this.disposalField(filter.mediaClassId),
        partnerName: this.disposalField(filter.mediaPartnerName),
        duration: filter.mediaClassId === 2 ? 15 : (filter.mediaClassId === 3 ? 30 : undefined),
        mateCheckCode: this.disposalField(filter.mateCheckCode)
      }
      // 检索名称或id
      if (this.projectOrder.selectNameType !== 3) {
        params.searchParamType = this.projectOrder.selectNameType
        params.searchParam = this.projectOrder.searchParam
      }
      this.loading = true
      this.$service
        .getThirdMaterialList(params)
        .then((data) => {
          this.pager.total = data.total
          this.table.data = data.rows
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pager.pageNo = 1
      this.pager.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pager.pageNo = val
      this.fetchData()
    },
    disposalField(value) {
      if (value !== '' && value !== undefined) {
        return value
      }
    },
    async handleRead(row, tabs) {
      this.mediaId = row.mateId
      this.scheduleId = row.scheduleId
      await this.handleOpenDrawer()
      this.showDrawer = true
      this.drawerTabsActiveName = tabs
    },
    handleReloadContent() {
      this.fetchData()
      this.handleOpenDrawer()
    },
    handleOpenDrawer() {
      this.loading = true
      return this.$service
        .getMaterialById({ mediaId: this.mediaId, scheduleId: this.scheduleId })
        .then((data) => {
          this.loading = false
          if (data) {
            this.mediaModel = data
            this.mediaModel.activeEventTab = 'keyEventList'
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleEdit(row) {
      const rowData = {
        mediaId: row.mateId,
        orderName: row.adOrder.orderName,
        scheduleId: row.scheduleId,
        scheduleName: row.adSchedule.scheduleName,
        scheduleSource: row.adSchedule.scheduleSource,
        supportMode: row.adSchedule.supportMode,
        partnerId: row.partnerId,
        spaceId: row.adSchedule.spaceId,
        spaceNo: row.adMedia.adSpace.spaceNo,
        recId: row.adSchedule.scheduleSub ? row.adSchedule.scheduleSub.recId : undefined
      }
      this.$emit('edit', rowData)
    },
    handleCommand(row, command) {
      if (command === 'log') {
        this.handleRead(row, 'log')
      } else if (command === 'download') {
        this.$service.downLoadImgFile({ mediaId: row.mateId }).then((result) => {
          const a = document.createElement('a')
          a.href = result.url
          a.target = '_self'
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
      } else if (command === 'delete') {
        this.$confirm('确定要删除该创意吗？', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          center: true,
          showClose: false
        })
          .then(() => {
            this.$service.removeThirdMaterialList([{ mateId: row.mateId, scheduleId: row.scheduleId }]).then(res => {
              this.$message.success('删除成功！')
              this.fetchData()
            })
          })
          .catch(() => {})
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-content
  padding 0 16px
.operate-nav
  margin 16px 0
>>>.cell-content-grid
  width 100%
  padding-left 12px
  overflow hidden
  display -webkit-box
  display -moz-box
  text-overflow ellipsis
  -webkit-line-clamp 1
  -webkit-box-orient vertical
  white-space normal
</style>

<style lang="stylus">
.cell-button,.el-table-button-text
  color #1890ff
  &:focus,&:hover
    color #1890ff
</style>
